// Environment utilities for showing/hiding development features
export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === 'development';
};

export const isProduction = (): boolean => {
  return process.env.NODE_ENV === 'production';
};

export const isTest = (): boolean => {
  return process.env.NODE_ENV === 'test';
};

// Check if testing features should be shown
export const shouldShowTestingFeatures = (): boolean => {
  // Show testing features in development or if explicitly enabled
  return isDevelopment() || process.env.REACT_APP_SHOW_TESTING === 'true';
};

// Check if debug features should be shown
export const shouldShowDebugFeatures = (): boolean => {
  // Show debug features in development or if explicitly enabled
  return isDevelopment() || process.env.REACT_APP_SHOW_DEBUG === 'true';
};

// Check if admin features should be shown
export const shouldShowAdminFeatures = (): boolean => {
  // Show admin features in development or if user is admin
  return isDevelopment() || process.env.REACT_APP_ADMIN_MODE === 'true';
};

// Get user mode based on environment and user preferences
export const getUserMode = (): 'creator' | 'business' | 'developer' | 'admin' => {
  if (isDevelopment()) return 'developer';
  if (process.env.REACT_APP_USER_MODE) {
    return process.env.REACT_APP_USER_MODE as any;
  }
  return 'creator'; // Default mode
};

// Check if feature should be visible based on user mode
export const shouldShowFeature = (feature: string, userMode: string = getUserMode()): boolean => {
  const featureVisibility: Record<string, string[]> = {
    'creator': ['content', 'audience', 'analytics', 'brand', 'reader'],
    'business': ['content', 'audience', 'analytics', 'automation', 'account'],
    'developer': ['content', 'audience', 'analytics', 'automation', 'brand', 'reader', 'testing', 'debug'],
    'admin': ['content', 'audience', 'analytics', 'automation', 'brand', 'reader', 'testing', 'debug', 'admin']
  };

  return featureVisibility[userMode]?.includes(feature) || false;
};
